import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

const AttractionError = (props) => {
  return (
    <Modal
      className="publshedpost-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {/* <Modal.Header closeButton></Modal.Header> */}
      <Modal.Body>
        <div className="post-success-body">
          <h2 style={{ marginBottom: "40px", fontSize: "22px" }}>
            Error: {props.error}
          </h2>
          {/* <div className="modal-image">
            <img src={postsuccess} alt="published post image" />
          </div> */}
          {/* <button onClick={props.onHide} className="secondary-button" >
            Cancel
          </button> */}
          <div className="dashboard-btn" onClick={props.onHide}>
            <Link to="#" className="button">
              Ok
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AttractionError;
